(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
      this.applySelected();
      // Re-apply once the quantity selector custom element is upgraded, in case
      // it initializes its input value after we set it.
      if (window.customElements) {
        customElements.whenDefined('quantity-selector-component').then(() => this.applySelected());
      }
      // Recompute bundle prices when the variant changes. Horizon dispatches
      // 'shopify:product:select' with a promise resolving to the freshly
      // rendered product HTML (server-rendered for the new variant), so we just
      // pull our own re-rendered pricing out of it. No price data is hardcoded.
      this.section = this.closest('.shopify-section') || document;
      this.section.addEventListener('shopify:product:select', this.onProductSelect);

      // Intercept Add to cart when the per-unit selectors hold MIXED variants:
      // the extra variants are added via /cart/add.js first, then the native
      // submit runs for the remaining group so Horizon's drawer refresh/open
      // behaviour is preserved.
      const component = this.closest('product-form-component') || document.querySelector('product-form-component');
      this.atcButton = component ? component.querySelector('[ref="addToCartButton"]') : null;
      this.atcButton?.addEventListener('click', this.onAtcClick);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.section?.removeEventListener('shopify:product:select', this.onProductSelect);
      this.atcButton?.removeEventListener('click', this.onAtcClick);
    }

    onAtcClick = (event) => {
      if (this.bypassIntercept) {
        this.bypassIntercept = false;
        return;
      }

      const units = this.activeUnitSelects();
      if (!units.length) return;

      const form = this.atcButton?.closest('form');
      const idInput = form?.querySelector('input[name="id"], select[name="id"]');
      const qtyInput = form?.querySelector('input[name="quantity"]');
      if (!form || !idInput || !qtyInput) return;

      // Group the chosen variants.
      const counts = new Map();
      for (const select of units) {
        const id = select.value;
        counts.set(id, (counts.get(id) || 0) + 1);
      }
      if (counts.size <= 1) {
        // All units share one variant — let the native single-item flow run.
        const onlyId = units[0].value;
        if (onlyId && onlyId !== String(idInput.value)) idInput.value = onlyId;
        qtyInput.value = String(units.length);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (this.addingMixed) return;
      this.addingMixed = true;

      // The variant currently in the form stays on the native submit when
      // possible (keeps the picker UI consistent); the rest go via cart/add.js.
      const currentId = String(idInput.value);
      const nativeId = counts.has(currentId) ? currentId : units[0].value;
      const items = [];
      for (const [id, quantity] of counts) {
        if (id !== nativeId) items.push({ id: Number(id), quantity });
      }

      const finishWithNative = () => {
        if (nativeId !== String(idInput.value)) idInput.value = nativeId;
        qtyInput.value = String(counts.get(nativeId));
        this.addingMixed = false;
        this.bypassIntercept = true;
        this.atcButton.click();
      };

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('cart/add failed: ' + response.status);
        })
        .catch((error) => {
          console.warn('[bundle-selector] mixed-variant add failed for extra items:', error);
        })
        .finally(finishWithNative);
    };

    activeUnitSelects() {
      const checked = this.querySelector('.bundle-card__radio:checked');
      const card = checked ? checked.closest('.bundle-card') : null;
      return card ? Array.from(card.querySelectorAll('[data-unit-select]')) : [];
    }

    onChange = (event) => {
      if (event.target instanceof HTMLInputElement && event.target.type === 'radio') {
        this.applySelected();
        return;
      }
      // "Dog 1" drives the (visually hidden) native variant picker so the
      // gallery, price and ATC morph exactly as if the picker was clicked.
      if (event.target instanceof HTMLSelectElement && event.target.dataset.unitIndex === '0') {
        this.syncVariantPicker(event.target.value);
      }
    };

    syncVariantPicker(variantId) {
      const scope = this.closest('.shopify-section') || document;
      const radio = scope.querySelector('variant-picker input[type="radio"][data-variant-id="' + variantId + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    onProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      const promise = event.promise;
      if (!promise) return;

      promise
        .then(({ detail }) => {
          const html = detail && detail.html;
          if (!html) return;

          const blockId = this.dataset.blockId;
          const fresh =
            (blockId && html.querySelector('bundle-selector[data-block-id="' + blockId + '"]')) ||
            html.querySelector('bundle-selector');
          if (!fresh) return;

          // Swap only the pricing of each card (title/badge/radio/checked state
          // and quantity mapping don't depend on the variant).
          const freshCards = fresh.querySelectorAll('.bundle-card');
          const cards = this.querySelectorAll('.bundle-card');
          cards.forEach((card, index) => {
            const freshCard = freshCards[index];
            if (!freshCard) return;
            const nextPricing = freshCard.querySelector('.bundle-card__pricing');
            const currentPricing = card.querySelector('.bundle-card__pricing');
            if (nextPricing && currentPricing) {
              currentPricing.replaceWith(nextPricing);
            } else if (!nextPricing && currentPricing) {
              currentPricing.remove();
            }
            // Keep the per-unit price/save data in sync with the new variant.
            const freshRadio = freshCard.querySelector('.bundle-card__radio');
            const radio = card.querySelector('.bundle-card__radio');
            if (freshRadio && radio) {
              radio.dataset.unitPrice = freshRadio.dataset.unitPrice || '';
              radio.dataset.save = freshRadio.dataset.save || '0';
            }
          });
          // Re-propagate quantity/discount/unit-price to the ATC price module.
          this.applySelected();
        })
        .catch((error) => {
          if (error && error.name !== 'AbortError') console.warn('[bundle-selector] product select failed:', error);
        });
    };

    applySelected() {
      const checked = this.querySelector('.bundle-card__radio:checked');
      if (!checked) return;
      const quantity = parseInt(checked.value, 10) || 1;
      const savePercent = parseInt(checked.dataset.save, 10) || 0;

      const component = this.closest('product-form-component') || document.querySelector('product-form-component');
      if (!component) return;
      const form = component.querySelector('form') || component.closest('form') || component;

      // The field FormData actually submits to /cart/add. Write it directly so
      // it works even with no visible quantity selector or before it upgrades.
      let input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }
      input.value = String(quantity);

      // Keep the visible quantity selector (if any) in sync.
      const selector = component.querySelector('quantity-selector-component');
      if (selector && typeof selector.setValue === 'function') selector.setValue(quantity);

      component.dataset.quantityDefault = String(quantity);
      // Store the selected bundle's discount % AND exact per-unit price (cents)
      // on the product form so the ATC price can show the discounted total
      // (survives the button's variant morph). The exact price wins when set.
      component.dataset.discountPercent = String(savePercent);
      component.dataset.unitPriceCents = checked.dataset.unitPrice || '';

      // Carry the chosen sizes over when switching bundles (extra units
      // default to the last chosen size).
      const card = checked.closest('.bundle-card');
      if (this.lastCard && this.lastCard !== card && card) {
        const prev = this.lastCard.querySelectorAll('[data-unit-select]');
        if (prev.length) {
          card.querySelectorAll('[data-unit-select]').forEach((select, index) => {
            const source = prev[index] || prev[prev.length - 1];
            select.value = source.value;
          });
        }
      }
      this.lastCard = card;

      // Notify the theme that the quantity changed (same event the native +/-
      // buttons fire), so the Add to cart price, price-per-item and sticky ATC
      // recompute. Writing input.value directly doesn't fire events on its own.
      input.dispatchEvent(
        new CustomEvent('quantity-selector:update', { bubbles: true, detail: { quantity } })
      );
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gyrah-mini-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gyrMrev) return;
    window.__gyrMrev = true;

    function build(track) {
      if (track.dataset.gyrBound) return;
      track.dataset.gyrBound = '1';
      var cards = Array.prototype.filter.call(track.children, function (el) {
        return el.nodeType === 1;
      });
      if (cards.length < 2) return;

      var nav = document.createElement('div');
      nav.className = 'gyr-nav';

      function arrow(dir, path) {
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'gyr-nav__arrow';
        el.setAttribute('aria-label', dir === 'prev' ? 'Précédent' : 'Suivant');
        el.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
        return el;
      }

      var prev = arrow('prev', 'M15 5l-7 7 7 7');
      var next = arrow('next', 'M9 5l7 7-7 7');
      var dots = document.createElement('div');
      dots.className = 'gyr-nav__dots';

      function index() {
        var middle = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var gap = Infinity;
        cards.forEach(function (card, i) {
          var d = Math.abs(card.offsetLeft - track.offsetLeft + card.offsetWidth / 2 - middle);
          if (d < gap) { gap = d; best = i; }
        });
        return best;
      }

      function goTo(i) {
        var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
        if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gyr-nav__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Avis ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dots.appendChild(dot);
      });

      prev.addEventListener('click', function () { goTo(index() - 1); });
      next.addEventListener('click', function () { goTo(index() + 1); });
      nav.appendChild(prev);
      nav.appendChild(dots);
      nav.appendChild(next);
      track.parentElement.appendChild(nav);

      function sync() {
        var active = index();
        Array.prototype.forEach.call(dots.children, function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
        prev.disabled = active === 0;
        next.disabled = active === cards.length - 1;
      }
      sync();

      var pending = null;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; sync(); }, 60);
      });
    }

    function init() {
      document.querySelectorAll('[data-gyr-mrev-track]').forEach(build);
    }

    init();
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gyrah-sp-scarcity"] && !Shopify.designMode) return;
  try {
    if (!window.__gysScarce) {
    window.__gysScarce = true;
    var arm = function () {
      var els = document.querySelectorAll('[data-gys-scarce].gys-scarce--anim:not(.is-armed)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
      els.forEach(function (el) {
        el.classList.add('is-armed');
        // Laisser le navigateur peindre la largeur 0 avant d'observer, sinon pas de transition.
        requestAnimationFrame(function () { setTimeout(function () { io.observe(el); }, 60); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
    document.addEventListener('shopify:section:load', arm);
  }
  } catch(e) { console.error(e); }
})();

})();
